import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

registerRegisterDetail('B32005', {
  title: 'Allotment of Shares',
  repeatArrayPath: 'shareholders',
  fields: [
    { label: 'Entity Name', key: ['entityName.value', 'entityName', 'companyName'] },
    { label: 'Entity UEN', key: ['entityRegNo.value', 'entityRegNo', 'companyRegistrationNo'] },
    { label: 'Transaction Date', key: ['transactionDate'] },
    { label: 'Shareholder', key: ['shareholders.0.shareholderName', 'shareholderName'] },
    { label: 'Currency', key: ['shareholders.0.currencies.0.currencyName', 'currencyName'] },
    { label: 'Class of Shares', key: ['shareholders.0.currencies.0.shareClasses.0.classOfSharesName', 'classOfSharesName'] },
    { label: 'Number of Shares', key: ['shareholders.0.currencies.0.shareClasses.0.numberOfShares', 'numberOfShares'] },
  ],
});
